<template>
    <div id="app" class="panel-constructor invisible">
        <div id="editor-content" :data-device="device">

            <component v-for="(element,index) in elements" :key="index" :is="element.name" :config="element.config"
                       :childs="element.childs">
            </component>

            <sweet-modal v-for="(popup, index) in userPopups" :key="'popup' + popup.id" :ref="'popup' + popup.id"
                         width="100%">
                <component v-for="(element,index2) in  JSON.parse(popup.content)" :key="index2" :is="element.name"
                           :config="element.config"
                           :childs="element.childs">
                </component>
            </sweet-modal>

            <sweet-modal ref="videoModal" v-on:close="yourHandlerForCloseHere">
                <iframe width="990" height="500" ref="videoModalIframe" class="desktop-element" frameborder="0"
                        allowfullscreen></iframe>
                <iframe style="margin-left: 5%;" width="330" height="315" ref="videoModalIframeMobile"
                        class="mobile-element" frameborder="0" allowfullscreen></iframe>
            </sweet-modal>

            <sweet-modal icon="error" ref="required_fields">
                <div style="padding-top: 20px">
                    <p v-for="message in errorMessage">{{ message }}</p>
                </div>
            </sweet-modal>


            <sweet-modal icon="success" ref="success_send">
                Message sent successfully
            </sweet-modal>

        </div>
    </div>
</template>

<script>


	require('./components/base/editor/editor.scss')

	import PanelElement from "./components/apps/Panel/Panel.vue";
	import {SweetModal} from 'sweet-modal-vue'
	import {isMobile} from 'mobile-device-detect';
	import axios from 'axios';


	export default {
		name: 'app',
		components: {
			PanelElement,
			SweetModal
		},
		data() {
			return {
				fixedStartPanel: 0,
				device: isMobile ? 'mobile' : 'desktop',
				errorMessage: [],
				elements: [],
				userPopups: [],
				fontGroup: {},
				popupKeys: [],
				bgPropsPage: {},
				popupSettings: {},
				scrollPopup: false,
				isMobile: isMobile,
				cookieTypes: {
					preferences: {
						type: 'Site Preferences',
						value: 'preferences',
						description: 'These are cookies that are related to your site preferences, e.g. remembering your username, site colours, etc.'
					},
					analytics: {
						type: 'Analytics',
						value: 'analytics',
						description: 'Cookies related to site visits, browser types, etc.'
					},
					marketing: {
						type: 'Marketing',
						value: 'marketing',
						description: 'Cookies related to marketing, e.g. newsletters, social media, etc'
					}
				},
			}
		},
		methods: {

			yourHandlerForCloseHere() {
				this.$refs.videoModalIframe.src = '';
				this.$refs.videoModalIframeMobile.src = '';
			},

			applyFontGroup: function () {
				Object.keys(this.fontGroup).forEach(font => {
					document.body.style.setProperty('--text-family-' + font, this.fontGroup[font].family);
					document.body.style.setProperty('--text-size-' + font, this.fontGroup[font].size);
					document.body.style.setProperty('--text-size-mobile-' + font, this.fontGroup[font].sizeMobile);
					document.body.style.setProperty('--text-color-' + font, this.fontGroup[font].color);
					// document.body.style.setProperty('--text-line-height-' + font, this.fontGroup[font]['line-height']);
				});
			},

			applyBackground() {

				let bg = this.bgPropsPage.backgroundColor;


				if (this.bgPropsPage.backgroundImage !== 'none') {
					bg += ' url("' + this.bgPropsPage.backgroundImage + '")';
					bg += ' ' + this.bgPropsPage.backgroundPosition;
					bg += ' / ' + this.bgPropsPage.backgroundSize;
					bg += ' ' + this.bgPropsPage.backgroundRepeat;
					bg += ' ' + this.bgPropsPage.backgroundOrigin;
				}


				document.body.style.setProperty('--bg-page', bg);
			},

			applyPopups() {

				class EventHandlerClass {
					constructor() {
						this.functionMap = {};
					}

					addEventListener(event, func) {
						this.functionMap[event] = func;
						document.addEventListener(event.split('.')[0], this.functionMap[event]);
					}

					removeEventListener(event) {
						document.removeEventListener(event.split('.')[0], this.functionMap[event]);
						delete this.functionMap[event];
					}
				}

				const EventHandler = new EventHandlerClass();

				let vm = this;

				this.userPopups.forEach(popup => {
					// if(is_desktop)
					let $popup = this.isMobile ? this.popupSettings.mobile : this.popupSettings.desktop;


					if ($popup.popup_id == popup.id) {
						if ($popup.type === 'time') {
							setTimeout(function () {
								vm.$refs['popup' + popup.id][0].open();
							}, ((parseInt($popup.min * 60)) + parseInt($popup.sec)) * 1000)
						}
						if ($popup.type === 'scroll') {

							var scrollListener = function () {
								function showPosition(elm) {
									let parent = elm.parentNode,
										pos = (elm.scrollTop || parent.scrollTop) / (parent.scrollHeight - parent.clientHeight) * 100;

									return parseInt(pos);
								}

								let pos = showPosition(document.getElementById('editor-content'));
								console.log(pos, $popup.scroll);
								if (pos >= $popup.scroll && !vm.scrollPopup) {
									vm.$refs['popup' + popup.id][0].open();

									vm.scrollPopup = true;
								}
							};

							document.addEventListener('scroll', scrollListener, true /*Capture event*/);
						}
						if ($popup.type === 'exit') {
							EventHandler.addEventListener("mouseout.popup", evt => {
								if (evt.toElement === null && evt.relatedTarget === null) {
									vm.$refs['popup' + popup.id][0].open();

									EventHandler.removeEventListener("mouseout.popup", () => {
									});
								}
							});
						}
					}
				})
			},

			printScripts(scripts) {

				if (scripts.indexOf('marketing') > -1) {
					if (typeof layoutScriptsFb !== 'undefined') {
						try {
							$(layoutScriptsFb).appendTo($("head"));
						} catch (e) {
							console.log('broken layoutScriptsFb')
						}
					}
				}
				if (scripts.indexOf('analytics') > -1) {
					if (typeof layoutScriptsGa !== 'undefined') {
						try {
							$(layoutScriptsGa).appendTo($("head"));
						} catch (e) {
							console.log('broken layoutScriptsGa')
						}
					}
				}
				if (scripts.indexOf('necessary') > -1) {
					if (typeof layoutScripts !== 'undefined') {
						try {
							$(layoutScripts).appendTo($("head"));
						} catch (e) {
							console.log('broken layoutScripts')
						}
					}
					if (typeof pageScripts !== 'undefined') {
						try {
							$(pageScripts).appendTo($("head"));
						} catch (e) {
							console.log('broken pageScripts')
						}
					}
				}


				if (typeof OPTIONS_INIT_SITE !== 'undefined' &&
					typeof OPTIONS_INIT_SITE.options !== 'undefined' &&
					typeof OPTIONS_INIT_SITE.options.crmEnable !== 'undefined' &&
					OPTIONS_INIT_SITE.options.crmEnable === '1'
				) {

					var script = document.createElement("script");
					script.innerHTML = "(function({d=document,s='script',id='bacrmtrk', cKey, oKey}){\n" +
						"    let n, p = d.getElementsByTagName(s)[0];\n" +
						"    if (d.getElementById(id)) {return;}\n" +
						"    n = d.createElement(s); n.id = id;\n" +
						"    n.src = \"https://crm-api.eb4us.com/js/tracking.min.js\";\n" +
						"    n.onload = function(){__baCRMTracking.init({cKey, oKey})}\n" +
						"    p.parentNode.insertBefore(n, p);\n" +
						"  }({}));";
					document.head.appendChild(script);
				}
			},

			getCookie(cname) {
				var name = cname + "=";
				var decodedCookie = decodeURIComponent(document.cookie);
				var ca = decodedCookie.split(';');
				for (var i = 0; i < ca.length; i++) {
					var c = ca[i];
					while (c.charAt(0) == ' ') {
						c = c.substring(1);
					}
					if (c.indexOf(name) == 0) {
						return c.substring(name.length, c.length);
					}
				}
				return "";
			}

		},
		mounted() {


			$('.seo-power-texts').css({'display': 'none'});

			let vm = this;

			if (typeof gdprSettings !== 'undefined' && gdprSettings !== false && gdprSettings.active) {


				if (vm.getCookie('cookieControl')) {
					vm.printScripts(['necessary']);
					vm.printScripts($.fn.ihavecookies.cookie())
				}

				document.body.style.setProperty('--backgroundColor', gdprSettings.backgroundColor);
				document.body.style.setProperty('--colorTitle', gdprSettings.colorTitle);
				document.body.style.setProperty('--colorParagraph', gdprSettings.colorParagraph);
				document.body.style.setProperty('--colorLink', gdprSettings.colorLink);
				document.body.style.setProperty('--buttonBackground', gdprSettings.buttonBackground);
				document.body.style.setProperty('--buttonColor', gdprSettings.buttonColor);
				document.body.style.setProperty('--buttonAdvBackground', gdprSettings.buttonAdvBackground);
				document.body.style.setProperty('--buttonAdvColor', gdprSettings.buttonAdvColor);

				vm.cookieTypes['preferences'].type = gdprSettings['cookieTypes.preferences.type'];
				vm.cookieTypes['preferences'].description = gdprSettings['cookieTypes.preferences.description'];

				vm.cookieTypes['analytics'].type = gdprSettings['cookieTypes.analytics.type'];
				vm.cookieTypes['analytics'].description = gdprSettings['cookieTypes.analytics.description'];

				vm.cookieTypes['marketing'].type = gdprSettings['cookieTypes.marketing.type'];
				vm.cookieTypes['marketing'].description = gdprSettings['cookieTypes.marketing.description'];


				$('.panel-constructor').ihavecookies({
					title: gdprSettings.title,
					message: gdprSettings.message,
					expires: gdprSettings.expires,
					cookieTypes: vm.cookieTypes,
					link: gdprSettings.link,
					moreInfoLabel: gdprSettings.moreInfoLabel,
					acceptBtnLabel: gdprSettings.acceptBtnLabel,
					advancedBtnLabel: gdprSettings.advancedBtnLabel,
					uncheckBoxes: false,
					cookieTypesTitle: gdprSettings.cookieTypesTitle,
					fixedCookieTypeLabel: gdprSettings.fixedCookieTypeLabel,
					fixedCookieTypeDesc: gdprSettings.fixedCookieTypeDesc,
					onAccept: function () {
						if (vm.getCookie('cookieControl')) {
							vm.printScripts(['necessary']);
							vm.printScripts($.fn.ihavecookies.cookie())
						}
					},

				});

				if (typeof gdprSettings.position === 'undefined' || gdprSettings.position === '') {
					gdprSettings.position = 'bottom-right';
				}

				setTimeout(function () {
					$('#gdpr-cookie-message').addClass(gdprSettings.position);
					$('#gdpr-cookie-advanced').on('click', function () {
						setTimeout(function () {
							$('#gdpr-cookietype-analytics').prop('checked', true);
							$('#gdpr-cookietype-preferences').prop('checked', true);
							$('#gdpr-cookietype-marketing').prop('checked', true);
						}, 1000);
					});
				}, 2000);

			} else {
				vm.printScripts(['necessary', 'marketing', 'preferences', 'analytics']);
			}


			var query = location.hash;


			var hasValue = false;
			var originalValue = 0;

			if (typeof OPTIONS_INIT_SITE !== 'undefined') {
				hasValue = true;
				originalValue = OPTIONS_INIT_SITE.options;
			}

			if (query != '') {
				if (query.indexOf('aid') >= 0) {
					var aid = query.split('&')[0];
					window.aid_office = aid;
					let OPTIONS_INIT_SITE = {};
					OPTIONS_INIT_SITE.options = {};
					OPTIONS_INIT_SITE.options.dominio_original = window.location.host.toLocaleLowerCase();
					OPTIONS_INIT_SITE.options.domain = window.location.host.toLocaleLowerCase();

					if (hasValue) {
						OPTIONS_INIT_SITE.options = originalValue
					} else {
						OPTIONS_INIT_SITE.options.lang = 'en_US';
					}


					window.OPTIONS_INIT_SITE = OPTIONS_INIT_SITE

// if (!hasValue) {

					var date = new Date(),
						current_hour = date.getTime();


					var script = document.createElement('script');

					script.setAttribute('src', 'https://office.builderall.com/scripts/pixel/pixel-bundle.js?v=' + current_hour);

					document.head.appendChild(script);

					var script2 = document.createElement('script');

					script2.setAttribute('src', 'https://office.builderall.com/scripts/funis/complements.js?v=' + current_hour);

					document.head.appendChild(script2);
// }


				}
			}

			if (
				typeof OPTIONS_INIT_SITE !== 'undefined' &&
				typeof OPTIONS_INIT_SITE.options !== 'undefined' &&
				typeof OPTIONS_INIT_SITE.options.id_office_user !== 'undefined'
			) {
				axios.get('https://www.omb11.com/get/pixel-isolated?aid=' + OPTIONS_INIT_SITE.options.id_office_user)
					.then((res) => {
						console.log(res.data);

						$("#getfranchiseScript").empty();
						$("#getfranchiseScript").html(res.data);
					})
			}


			this.$root.$on('setFixedStartPanel', (val) => {
				this.fixedStartPanel = val;
			});
			this.$root.$on('linkAction', (link) => {
				console.log(link);

				switch (link.type) {

					case 'web' : {

						if (link.value !== '') {
							if (link.target === '_blank') {
								window.open(link.value, '_blank');
							} else {
								window.location.href = link.value
							}
						}
						break;
					}
					case 'page' : {


						pagesConfig.forEach(page => {
							if (link.valueID == page.id) {
								if (link.target === '_blank') {
									window.open('/' + page.url, '_blank');
								} else {
									window.location.href = '/' + page.url
								}
							}
						});
						break;
					}
					case 'anchor' : {
						let pageAnchor = {};
						let anchorName = '';

						pagesConfig.forEach(page => {

							if (typeof page !== 'undefined' && typeof page.configs !== 'undefined') {
								page.configs.forEach(config => {
									if (config.key === 'anchors') {
										let anchors = JSON.parse(config.value);
										if (typeof anchors[link.valueID] !== 'undefined') {
											pageAnchor = page;
											anchorName = anchors[link.valueID];
										}
									}
								});
							}
						});

						if (anchorName !== '')
							window.location.href = '/' + pageAnchor.url + '#' + anchorName;

						break;
					}

					case 'popup' : {
						let vm = this;
						console.log(this.userPopups);

						this.userPopups.forEach(popup => {
							console.log(popup);
							if (link.valueID == popup.id) {
								vm.$refs['popup' + popup.id][0].open();
							}
						})
						break;
					}
					case 'video' : {
						if (link.value !== '') {

							this.$refs.videoModalIframe.src = link.value;
							this.$refs.videoModalIframeMobile.src = link.value;
							this.$refs.videoModal.open();
						}

						break;
					}
				}
			});

			this.$root.$on('errorMessagePopup', (errors) => {
				this.errorMessage = errors;
				this.$refs.required_fields.open();
			});
			this.$root.$on('successMessagePopup', () => {
				this.$refs.success_send.open();
			});

			this.$root.$on('applyAnimation', (vm, defaultClass) => {
//clean and restore default classes
				vm.$el.className = '';
				$(vm.$el).off(".animation");
				vm.$el.classList.add(defaultClass);

//prep;
				let animation = vm.internal_config.animation.in;

				if (animation.effect.indexOf('In') !== -1) {
					vm.$el.classList.add('invisible');
				}

//apply
				let infinite = animation.infinite === true ? vm.$el.classList.add('infinite') : '';
				vm.$el.classList.add(animation.speed);

//apply time
				switch (animation.action) {
					case 'time':
						setTimeout(function () {
							vm.$el.classList.remove('invisible');
							vm.$el.classList.add(animation.effect, 'animated');
						}, animation.time * 1000);
						break;
					case 'click':
						$(vm.$el).on('click.animation', () => {
							vm.$el.classList.remove('invisible');
							vm.$el.classList.add(animation.effect, 'animated');
							if (!infinite) {
								vm.$el.addEventListener('animationend', function () {
									vm.$root.$emit('applyAnimation', vm, defaultClass);
								});
							}
						});
						break;
					case 'hover':
						$(vm.$el).on('mouseover.animation', () => {
							vm.$el.classList.remove('invisible');
							vm.$el.classList.add(animation.effect, 'animated');
							if (!infinite) {
								vm.$el.addEventListener('animationend', function () {
									vm.$root.$emit('applyAnimation', vm, defaultClass);
								});
							}
						});
						break;
					case 'scroll':

						let element = document.getElementById(vm.$el.id),
							bodyRect = document.body.getBoundingClientRect(),
							elemRect = element.getBoundingClientRect(),
							offset = elemRect.top - bodyRect.top;

						if (window.innerHeight >= offset) {
							vm.$el.classList.remove('invisible');
							vm.$el.classList.add(animation.effect, 'animated');
						}
						document.addEventListener('scroll', function () {
							if (document.getElementById('app').scrollTop + window.innerHeight >= offset) {
								console.log('aplicou');
								vm.$el.classList.remove('invisible');
								vm.$el.classList.add(animation.effect, 'animated');
							}
						}, true /*Capture event*/);

						break;
				}
			})
			let uri = window.location.search.substring(1);
			let params = new URLSearchParams(uri);

			if (typeof config === 'undefined' || config === '') {
				axios.get(window.location.origin = '/cheetah/publish')
					.then((res => {
						if (res.data === 'published') {
							location.reload();
						}
					}))
			}

			this.elements = config;

			if (typeof popupConst !== 'undefined') {
				this.userPopups = popupConst;

			}
			this.fontGroup = fontConfig;

// this.popupKeys = Object.keys(popupConst);

			this.applyFontGroup();

			if (window.location.pathname === '/') {

				let actualPage;

				try {
					pagesConfig.forEach((page) => {

						if (page !== null && page.initial === '1') {
							actualPage = page;
						}
					})
				} catch (e) {

				}

				if (typeof actualPage !== 'undefined' && typeof actualPage.configs !== 'undefined') {

					let pageConfig = actualPage.configs;
					Object.keys(pageConfig).forEach((idx) => {
						let config = pageConfig[idx];
						if (config.key === "bgPropsPage") {
							this.bgPropsPage = JSON.parse(config.value)
							this.applyBackground();
						}
						if (config.key === "popupSettings") {
							this.popupSettings = JSON.parse(config.value)
							this.applyPopups();
						}
					})

				}

			} else {

				var url = window.location.pathname.replace('/', '');

				var pageConfig = false;
				try {
					pagesConfig.forEach(page => {
						if (page.url.toLowerCase() == url.toLowerCase()) {
							pageConfig = page;
						}
					});

//find 404 page
					if (!pageConfig) {
						pagesConfig.forEach(page => {
							if (page.url == '404') {
								pageConfig = page;
							}
						});
					}

				} catch (e) {

				}

				if (typeof pageConfig !== 'undefined' && pageConfig !== false && pageConfig.configs !== null) {

					pageConfig.configs.forEach((config) => {
						if (config.key === "bgPropsPage") {
							this.bgPropsPage = JSON.parse(config.value);
							this.applyBackground();

						}
						if (config.key === "popupSettings") {
							this.popupSettings = JSON.parse(config.value);
							this.applyPopups();
						}
					})

				}

			}

			let hash = window.location.hash.substr(1);
			if (hash !== '') {
				setTimeout(function () {
					document.getElementById(hash).scrollIntoView({behavior: 'smooth'});
				}, 2000)
			}


			this.applyBackground();

			this.$nextTick(() => {
				let $siteBuilderPanel = $('.sitebuilder-element-panel');
				try {

					let all = document.querySelectorAll('span');

					for (var i = 0, max = all.length; i < max; i++) {
						all[i].style['-webkit-text-fill-color'] = all[i].style.color;
					}

					if ($('[data-fixed="true"]').length > 0) {
						$siteBuilderPanel.get(1).style.marginTop = vm.fixedStartPanel;
					} else {
						$siteBuilderPanel.get(1).classList.add('remove-margin-top')
					}

					if ($('[data-fixed-mobile="true"]').length > 0) {
						$siteBuilderPanel.get(1).style.marginTop = vm.fixedStartPanel;
					} else {
						$siteBuilderPanel.get(1).classList.add('remove-margin-top-mobile')
					}
				} catch (e) {

				}

				$('.panel-constructor').removeClass('invisible');
			})


			axios.get('/cheetah/version')
				.then(res => {
					console.log(res);
				});

		}


	}
</script>

<style lang="scss">


    .invisible {
        visibility: hidden;
    }

    [data-device="desktop"] {
        [data-fixed="true"] {
            position: fixed;
            left: 0;
            width: 100%;
            top: 0;
            z-index: 10000;
        }
    }

    [data-device="mobile"] {
        [data-fixed-mobile="true"] {
            position: fixed;
            width: 100%;
            top: 0;
            z-index: 10000;
        }
    }

    [data-device="desktop"] .remove-margin-top,
    [data-device="mobile"] .remove-margin-top-mobile {
        margin-top: 0 !important;
    }

    /* Cookie Dialog */
    #gdpr-cookie-message {
        position: fixed;

        max-width: 375px;
        background-color: var(--backgroundColor);
        padding: 20px;
        border-radius: 5px;
        box-shadow: 0 6px 6px rgba(0, 0, 0, 0.25);
        font-family: 'Roboto', sans-serif;
        z-index: 1000;

        &.bottom-right {
            right: 30px;
            bottom: 30px;
        }

        &.top-right {
            right: 30px;
            top: 30px;
        }

        &.bottom-left {
            left: 30px;
            bottom: 30px;
        }

        &.top-left {
            left: 30px;
            top: 30px;
        }

        &.full-bottom {
            bottom: 0;
            left: 0;
            max-width: none;
            width: 100%;

            * {
                max-width: 500px;
                margin: 5px auto;
            }
        }

        &.full-top {
            top: 0;
            left: 0;
            max-width: none;
            width: 100%;
            bottom: unset;

            * {
                max-width: 500px;
                margin: 5px auto;
            }
        }

        &.center-center {
            top: calc(50% - 90px);
            left: calc(50% - 187px);
        }

        h4 {
            color: var(--colorTitle);
            font-family: 'Roboto', sans-serif;
            font-size: 18px;
            font-weight: 500;
            margin-bottom: 10px;
        }

        h5 {
            color: var(--colorTitle);
            font-family: 'Roboto', sans-serif;
            font-size: 15px;
            font-weight: 500;
            margin-bottom: 10px;
        }

        input[type="checkbox"] {
            float: none;
            margin-top: 0;
            margin-right: 5px;
        }

        p, ul {
            color: var(--colorParagraph);
            font-size: 15px;
            line-height: 1.5em;

            &:last-child {
                margin-bottom: 0;
                text-align: right;
                padding-inline-start: 0 !important;
            }
        }

        li {
            width: 49%;
            display: inline-block;
            text-align: left;
        }

        a {
            color: var(--colorLink);
            text-decoration: none;
            font-size: 15px;
            padding-bottom: 2px;
            border-bottom: 1px dotted rgba(255, 255, 255, 0.75);
            transition: all 0.3s ease-in;

            &:hover {
                color: white;
                border-bottom-color: var(--colorLink);
                transition: all 0.3s ease-in;
            }
        }

        button {
            border: none;
            background: var(--buttonBackground);
            color: var(--buttonColor);
            font-family: 'Roboto', sans-serif;
            font-size: 15px;
            padding: 7px;
            border-radius: 3px;
            margin-left: 15px;
            cursor: pointer;
            transition: all 0.3s ease-in;
            max-width: 50% !important;

            &:hover {
                background: var(--buttonColor);
                color: var(--buttonBackground);
                transition: all 0.3s ease-in;
            }

            &:disabled {
                opacity: 0.3;
            }
        }
    }

    button#gdpr-cookie-advanced {
        background: var(--buttonAdvBackground);
        color: var(--buttonAdvColor);
        float: left;
    }

    .link-action {
        cursor: pointer;
    }

    @media (max-width: 980px) {

        .desktop-element {
            display: none !important;
        }

        .mobile-element {
            display: block !important;
        }

        .sitebuilder-element-container {
            position: relative !important;
            left: 0 !important;
            top: 0 !important;
            height: auto !important;
            width: auto !important;
            padding-top: 15px;
            padding-bottom: 15px;
        }

        .container-fluid {
            height: auto !important;
        }

        [element="ImageComponent"] img {
            width: 100% !important;
            max-width: 400px;
            height: auto !important;

        }

        [element="ImageComponent"] {

            text-align: center;
        }

    }

    @media (min-width: 979px) {

        .desktop-element {
            display: block !important;
        }

        .mobile-element {
            display: none !important;
        }

    }

</style>

